import { render, staticRenderFns } from "./Sincerely.vue?vue&type=template&id=fd262384&scoped=true"
import script from "./Sincerely.vue?vue&type=script&lang=js"
export * from "./Sincerely.vue?vue&type=script&lang=js"
import style0 from "./Sincerely.vue?vue&type=style&index=0&id=fd262384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd262384",
  null
  
)

export default component.exports